<template>
  <div class="report-tabs__wrapper">
    <!-- <main-menu-mobile class="hidden-sm-and-up"></main-menu-mobile> -->
    <a
      class="report-tabs__logo"
      @click="handleLogoClick"
    >
      <ui-icon size="14" :color="$colors.white" class="report-tabs__logo-bars hidden-md-and-up mr-8" icon="fas fa-bars"></ui-icon>

      <div class="report-tabs__logo-container">
<!--        <img-->
<!--          class="report-tabs__logo-tree"-->
<!--          alt=""-->
<!--          src="/images/christmas-tree.svg"-->
<!--        >-->
        <img
          class="report-tabs__logo-image" 
          alt="BeMob" 
          src="/images/logo-white2.svg"
        >
<!--        <img -->
<!--          class="report-tabs__logo-snowflakes" -->
<!--          alt="" -->
<!--          src="/images/snowflakes.svg"-->
<!--        >-->
      </div>
    </a>

    <div 
      class="report-tabs__tabs-host hidden-sm-and-down"
      ref="tabsHost"
    >
      <div
        :class="{ 
          'report-tabs': true,
          'v-tabs': true,
          'report-tabs--plain': true,
          'report-tabs--shadow': isComplexTabs,
          'hidden-sm-and-down': true,
        }"
        ref="tabs"
      >
        <span
          v-for="tab in reportTabs"
          :key="tab.key"
          class="report-tabs__tab hidden-sm-and-down v-tabs__item"
          :class="{
            'report-tabs__tab--home': !tab.hasBookmarks,
            'report-tabs__tab--active': tab.active,
            'report-tabs__tab--plain': tab.close
          }"
          @click="tab.click"
          @mousedown="handleTabItemMouseDown($event, tab)"
          @mouseup="handleTabItemMouseUp($event, tab)"
        >
          <ui-icon :icon="tab.icon" size="12" class="report-tabs__tab-icon mr-4"></ui-icon>
          <span class="report-tabs__tab-text">
            <v-tooltip :open-delay="1000" location="bottom" :open-on-click="false">
              <template #activator="{ props: tooltipProps }">
                <div class="report-tabs__tab-title" v-bind="tooltipProps">{{ tab.title }}</div>
              </template>
              <span>{{ tab.title }}</span>
            </v-tooltip>
          </span>
          <span 
            v-if="tab.hasBookmarks"
            class="report-tabs__tab-actions ml-4"
          >
            <report-tabs-actions 
              :item="tab"
              :has-bookmark="bookmarkIndexes[tab.meta.index] !== -1"
              @click.stop
              @open-bookmark="handleOpenBookmark({
                index: bookmarkIndexes[tab.meta.index],
                item: tab.meta.item,
                title: tab.title
              })"
            ></report-tabs-actions>
          </span>

          <a 
            v-if="tab.close"
            class="report-tabs__tab-icon--close"
            @click.stop="tab.close"
          >
            <ui-icon class="pl-10 pr-0" icon="fas fa-times"></ui-icon>
          </a>
        </span>
      </div>

      <div
        v-if="isComplexTabs"
        class="report-tabs v-tabs hidden-sm-and-down"
        ref="tabs2"
      >
        <span
          v-for="tab in reportTabs.filter((item) => !item.hideIfMany)"
          :key="tab.key"
          class="report-tabs__tab hidden-sm-and-down v-tabs__item"
          :class="{
            'report-tabs__tab--home': !tab.hasBookmarks,
            'report-tabs__tab--active': tab.active,
            'report-tabs__tab--plain': tab.close
          }"
          @click="tab.click"
          @mousedown="handleTabItemMouseDown($event, tab)"
          @mouseup="handleTabItemMouseUp($event, tab)"
        >
          <ui-icon :color="$colors.white" class="mr-4 report-tabs__tab-icon report-tabs__tab-icon--report" :icon="tab.icon"></ui-icon>
          <span class="report-tabs__tab-text">
            <v-tooltip :open-delay="1000" location="bottom" :open-on-click="false">
              <template #activator="{ props: tooltipProps }">
                <div class="report-tabs__tab-title" v-bind="tooltipProps">{{ tab.title }}</div>
              </template>
              <span>{{ tab.title }}</span>
            </v-tooltip>
          </span>
          <span 
            v-if="tab.hasBookmarks"
            class="report-tabs__tab-actions ml-4"
          >
            <report-tabs-actions 
              :item="tab"
              :has-bookmark="bookmarkIndexes[tab.meta.index] !== -1"
              @click.stop
              @open-bookmark="handleOpenBookmark({
                index: bookmarkIndexes[tab.meta.index],
                item: tab.meta.item,
                title: tab.title
              })"
            ></report-tabs-actions>
          </span>

          <a 
            v-if="tab.close"
            class="report-tabs__tab-icon--close"
            @click.stop="tab.close"
          >
            <ui-icon class="pl-10 pr-0" icon="fas fa-times"></ui-icon>
          </a>
        </span>

        <span
          ref="groupingTabRef"
          class="report-tabs__tab report-tabs__tab--grouping v-tabs__item"
          :class="{
            'report-tabs__tab--active': isGroupingActive,
            'report-tabs__tab--hide-tabs': !isManyReports && !isOverflowing && !forceShowGroupingTabs 
          }"
        >
          <v-menu
            v-if="isManyReports || isOverflowing || forceShowGroupingTabs"
            v-model="isGroupingOpen"
            location="bottom start"
            :offset="[0, -1]"
            :target="groupingTabRef ?? undefined"
            :transition="false"
            :content-class="menuContentClass"
            class="report-tabs__group-menu-wrapper"
          >
            <template #activator="{ props: activatorProps }">
            <a v-bind="activatorProps" class="report-tabs__group-menu-activator">
              <div class="report-tabs__group-menu-content-wrapper">
                <div v-if="mdAndUp" class="report-tabs__group-menu-content">
                  <ui-icon class="report-tabs__tab-icon report-tabs__tab-icon--report mr-4" :icon="currentCommonTabPropsNoHome.icon"></ui-icon>
                  <v-tooltip
                    class="report-tabs__grouping-list-item-tooltip report-tabs__tab-text"
                    :open-delay="1000"
                    location="bottom"
                  >
                    <template #activator="{ props: tooltipProps }">
                      <span v-bind="tooltipProps">{{ currentCommonTabPropsNoHome.name }}</span>
                    </template>
                    <span>{{ currentCommonTabPropsNoHome.name }}</span>
                  </v-tooltip>
                </div>

                <div v-else class="report-tabs__group-menu-content">
                  <ui-icon class="report-tabs__tab-icon report-tabs__tab-icon--report" :icon="currentCommonTabProps.icon"></ui-icon>
                  <span class="report-tabs__grouping-tab-text" style="display: inline-block; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">{{ currentCommonTabProps.name }}</span>
                </div>

                <div v-if="hasCommonTab" class="" style="display: flex;">
                  <div 
                    v-if="lastActiveTab"
                    class="report-tabs__tab-actions"
                  >
                    <report-tabs-actions 
                      :item="lastActiveTab"
                      :has-bookmark="lastActiveTab.meta && bookmarkIndexes[lastActiveTab.meta.index] !== -1"
                      @open-bookmark="handleOpenBookmark({
                        index: bookmarkIndexes[lastActiveTab.meta.index],
                        item: lastActiveTab.meta.item,
                        title: lastActiveTab.title
                      })"
                      @click.stop
                      @pointerdown.stop
                      @mousedown.stop
                    ></report-tabs-actions>
                  </div>

                  <a>
                    <ui-icon
                      class="pl-4 pr-0"
                      color="inherit"
                      :icon="isGroupingOpen ? 'fal fa-layer-group' : 'fas fa-layer-group'"
                    ></ui-icon>
                  </a>
                </div>
              </div>
            </a>
            </template>

            <v-list class="report-tabs__grouping-list">
              <v-list-item
                v-for="tab in reportTabsClosable"
                :key="tab.key"
                class="report-tabs__grouping-list-item"
                :class="{
                  'report-tabs__grouping-list-item--active': tab.active,
                }"
                @click="tab.click"
              >
                <div class="report-tabs__grouping-list-item-content">
                  <div class="report-tabs__grouping-list-item-main">
                    <ui-icon class="pr-4 report-tabs__grouping-list-item-icon" :icon="tab.icon"></ui-icon>
                    <v-tooltip
                      class="report-tabs__grouping-list-item-tooltip report-tabs__tab-text"
                      :open-delay="1000"
                      location="bottom"
                    >
                      <template #activator="{ props: tooltipProps }">
                        <span v-bind="tooltipProps" class="report-tabs__grouping-list-item-text">{{ tab.title }}</span>
                      </template>
                      <span>{{ tab.title }}</span>
                    </v-tooltip>
                  </div>

                  <div 
                    v-if="tab.hasBookmarks || tab.close" 
                    style="display: flex;"
                  >
                    <div 
                      v-if="tab.hasBookmarks"
                      class="report-tabs__tab-actions"
                    >
                      <bookmark-add
                        :index="bookmarkIndexes[tab.meta.index]"
                        :item="tab.meta.item"
                        :title="tab.title"
                      ></bookmark-add>
                    </div>

                    <a
                      v-if="tab.close"
                      @click.stop="tab.close"
                    >
                      <ui-icon
                        class="pl-10 pr-0 report-tabs__tab-icon-content report-tabs__tab-icon-content--close"
                        icon="fas fa-times"
                      ></ui-icon>
                    </a>
                  </div>
                </div>
              </v-list-item>
            </v-list>
          </v-menu>
        </span>
      </div>
    </div>

    <div 
      v-if="reportTabsClosable.length"
      class="report-tabs__close-all hidden-sm-and-down"
      @click="handleCloseAllTabs"
    >
      <ui-icon :color="$colors.red" class="report-tabs__close-all-icon mr-4" icon="fas fa-times"></ui-icon>
      <span class="report-tabs__close-all-text">{{t('Close all')}}</span>
    </div>

    <main-menu-report-tabs-mobile-item
      :class="{
        'report-tabs__mobile-dropdown': true,
        'report-tabs__mobile-dropdown--open': store.mobile.menuReportTabsOpen,
        'hidden-md-and-up': true
      }"
      ref="mobileReportTabs"
      :item="currentCommonTabProps"
      type="dropdown"
      :decorative-dropdown="store.mobile.menuReportTabsOpen"
      @click="handleOpenMobileMenu"
    ></main-menu-report-tabs-mobile-item>

  </div>
</template>

<script setup lang="ts">
import { useStore } from '@/store';

const store = useStore();
  import { useDisplay } from 'vuetify';
  import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue';
  import { useRoute } from 'vue-router';
  import { useColors, useI18n, useReportTabs, useTableQuery, useUrl } from '@/composables';
  import { $emitter } from '@/services/emitter';
  import helpers from '@/services/helpers';
  import BookmarkAdd from '@/components/bookmark/bookmark-add.vue';
  import MainMenuMobile from '@/views/layout/navigation/main-menu-mobile.vue';
  import MainMenuReportTabsMobileItem from '@/views/layout/navigation/grouping/main-menu-report-tabs-mobile-item.vue';
  import BookmarkAddMenu from '@/components/bookmark/bookmark-add-menu.vue';
  import ReportTabsActions from '@/views/reports/views/report-tabs-actions.vue';

  const getElementForBoundingRect = (
    tabsRef: { $el?: unknown } | HTMLElement | unknown[] | undefined,
    tabsHost: HTMLElement | undefined,
  ): HTMLElement | null => {
    const normalizedRef = Array.isArray(tabsRef) ? tabsRef[0] : tabsRef;
    if (normalizedRef instanceof HTMLElement && typeof normalizedRef.getBoundingClientRect === 'function') {
      return normalizedRef;
    }
    const root =
      normalizedRef && typeof normalizedRef === 'object' && '$el' in normalizedRef
        ? (normalizedRef as { $el?: unknown }).$el
        : undefined;
    if (root instanceof HTMLElement && typeof root.getBoundingClientRect === 'function') {
      return root;
    }
    if (root instanceof SVGElement && typeof root.getBoundingClientRect === 'function') {
      return root as unknown as HTMLElement;
    }
    const fromHost = tabsHost?.querySelector?.('.report-tabs');
    if (fromHost instanceof HTMLElement && typeof fromHost.getBoundingClientRect === 'function') {
      return fromHost;
    }
    return null;
  };

  const route = useRoute();
  const tableQueryApi = useTableQuery();
  const $colors = useColors();
  const { t } = useI18n();
  const { defaultHomepage, isSettingsRoute } = useUrl();
  const {
    activeReports,
    currentTab,
    lastActiveTab,
    reportTabs,
    reportTabsClosable,
    bookmarkIndexes,
    currentCommonTabProps,
    currentCommonTabPropsNoHome,
    commonTabsLength,
    isManyReports,
    hasCommonTab,
    clickTab,
    closeTab,
    closeAllTabs,
  } = useReportTabs();

  const { smAndUp, mdAndUp, mdAndDown } = useDisplay();

  const tabs = ref<unknown>();
  const tabsHost = ref<HTMLElement>();
  const groupingTabRef = ref<HTMLElement | null>(null);
  const isGroupingOpen = ref(false);
  const isOverflowing = ref(false);
  const lastBarWidth = ref(0);
  const menuOpened = ref<Record<number, boolean>>({});

  const showPlainTabs = computed(() => isManyReports.value || isOverflowing.value);
  const forceShowGroupingTabs = computed(
    () => !showPlainTabs.value && smAndUp.value && mdAndDown.value && hasCommonTab.value,
  );
  const isComplexTabs = computed(() =>
    commonTabsLength.value > 1
    && (isManyReports.value || isOverflowing.value || forceShowGroupingTabs.value),
  );
  const isGroupingActive = computed(() =>
    Boolean(currentTab.value && (currentTab.value.tabId === tableQueryApi.tableActiveTab.value || isSettingsRoute.value)),
  );
  const menuContentClass = computed(() =>
    ['hidden-sm-and-down', 'report-tabs__group-menu', !isGroupingActive.value ? 'report-tabs__group-menu--not-active' : ''].filter(Boolean).join(' '),
  );

  const recalcTabsWidth = () => {
    const tabsElement = getElementForBoundingRect(tabs.value as any, tabsHost.value);
    if (!tabsElement || !tabsHost.value || typeof tabsHost.value.getBoundingClientRect !== 'function') return;
    const rectTabs = tabsElement.getBoundingClientRect();
    const rectTabsHost = tabsHost.value.getBoundingClientRect();
    isOverflowing.value = rectTabs.width > rectTabsHost.width;
    lastBarWidth.value = rectTabs.width;
  };
  const onBusEntityChangeName = (payload: unknown) => {
    store.renameTableReportTab(payload as { id: string; name?: string; nameFull?: string });
  };
  const onWindowResize = () => {
    recalcTabsWidth();
  };
  const handleLogoClick = () => {
    if (mdAndUp.value) clickTab(defaultHomepage());
    else store.setMenuOpen(true);
  };
  const handleOpenBookmark = (options: unknown) => $emitter.emit('open-dialog', { name: 'BookmarkAddDialog', data: options });
  const handleTabItemMouseDown = (event: MouseEvent, tab: any) => {
    if (tab.meta && tab.meta.mouseEvents && event.button === 1) {
      event.preventDefault();
      return false;
    }
  };
  const handleTabItemMouseUp = (event: MouseEvent, tab: any) => {
    if (tab.meta && tab.meta.mouseEvents && event.button === 1) {
      nextTick(() => closeTab(event, tab.meta.tabId));
    }
  };
  const handleOpenMobileMenu = () => {
    store.setMenuReportTabsTop(40);
    const menuReportTabsOpen = store.mobile.menuReportTabsOpen;
    helpers.afterBrowserRedraw(() => store.setMenuReportTabsOpen(!menuReportTabsOpen));
  };
  const handleCloseAllTabs = (event: MouseEvent) => {
    event.stopPropagation();
    closeAllTabs();
  };

  watch(isManyReports, (value) => !value && (isGroupingOpen.value = false));
  watch(commonTabsLength, () => helpers.afterBrowserRedraw(() => recalcTabsWidth()));
  watch(() => route.fullPath, () => {
    const reportId = (route.query as any)?.exitReport;
    if (reportId) {
      store.removeTableReportTabById(reportId);
    }
  });
  onMounted(() => {
    $emitter.on('entity-change-name', onBusEntityChangeName);
    window.addEventListener('resize', onWindowResize);
    recalcTabsWidth();
  });
  onBeforeUnmount(() => {
    $emitter.off('entity-change-name', onBusEntityChangeName);
    window.removeEventListener('resize', onWindowResize);
  });
</script>

<style lang="scss">
.report-tabs {
  outline: none;
  --v-tabs-height: 32px;

  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  height: 32px;

  &--plain {
    position: absolute;
    width: unset;
    height: 32px;
  }

  &--shadow {
    opacity: 0;
    left: -9999px;
    top: -9999px;
  }

  &__tabs-host {
    position: relative; 
    flex-grow: 1; 
    height: 32px;
  }

  &__close-all {
    display: flex;
    align-items: center;
    font-size: 13px;
    cursor: pointer;

    margin-top: -8px;
    height: 40px;
    padding: 0 7px 0 5px;

    &-text {
      white-space: nowrap;
      font-size: 13px; 
      color: var(--color-white);
    }

    &:hover {
      .report-tabs__close-all-icon {
        color: var(--color-white)!important;
      }
    }
  }

  &__mobile-dropdown {
    flex-grow: 1; 
    margin-top: -8px; 
    border-left: 1px solid var(--color-white20);
    margin-left: 13px;

    &--open {
      border-left-color: transparent;
    }

    .menu-list-item__content {
      color: var(--color-white);

      &:hover {
        cursor: pointer;
        color: var(--color-white);

        .menu-list-item__icon {
          color: var(--color-white)  !important;
        }
      }
    }

    &.menu-list-item--selectable:hover  {
      .menu-list-item__content {
        color: var(--color-white);
        }

      .menu-list-item__icon {
        color: var(--color-white)  !important;
      }
    }
  }
  
  .v-tabs__container {
    height: 32px;
  }

  .v-tabs__bar {
    background-color: transparent;
  }

  &__tab-list {
    min-width: 0;
  }

  &__tab { 
    display: flex;
    align-items: center;
    height: 32px;
    min-height: 32px;
    cursor: pointer;
    margin-right: 8px;     
    background-color: var(--color-white20);
    border-radius: 6px 6px 0 0;
    flex-grow: 0 !important;
    color: var(--color-white) !important;

    &--grouping {
      max-width: 400px;
      overflow: hidden;
    }

    & &-icon,
    & &-icon .ui-icon {
      color: var(--color-white) !important;
    }

    &:hover { 
      background-color: var(--color-white40);
    }

    &.v-tabs__item,
    .v-tabs__item {
      border-radius: 6px 6px 0 0;
      border: 1px solid transparent;
      color: var(--color-white) !important;
      padding: 6px 8px !important;

      &.report-tabs__tab--grouping {
        padding: 6px 8px 6px 7px !important;
      }

      a,
      span,
      .report-tabs__tab-text,
      .report-tabs__grouping-tab-text {
        text-decoration: none;
        color: var(--color-white) !important;
        line-height: 1.3;
        max-width: 174px;
        cursor: pointer;
      }
    }

    &--active {
      background-color: var(--color-white);
      color: var(--color-graphite) !important;

      &:hover { 
        background-color: var(--color-white);
      }

      & .report-tabs__tab-icon,
      & .report-tabs__tab-icon .ui-icon {
        color: var(--color-graphite) !important;
      }

      &.v-tabs__item,
      .v-tabs__item {
        border: 1px solid var(--color-white);
        color: var(--color-graphite) !important;
      }

      a,
      span,
      .report-tabs__tab-text,
      .report-tabs__tab-title,
      .report-tabs__grouping-tab-text {
        color: var(--color-graphite) !important;
        cursor: pointer;
      }
    } 
  }

  &__tab--active.v-tabs__item {
    a,
    span,
    .report-tabs__tab-text,
    .report-tabs__tab-title,
    .report-tabs__grouping-tab-text {
      color: var(--color-graphite) !important;
      cursor: pointer;
    }
  }

  &__tab-title {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__wrapper {
    margin-top: 8px;
    display: flex; 
    width: 100%;
  }

  &__logo {
    display: flex;
    align-items: center;
    margin-top: -8px;
    padding: 8px 16px 0 16px;
    overflow:hidden;

    @media (max-width: 959px) {
      padding-top: 0;
      padding-bottom: 0;
      padding-right: 0;
    }
  }

  &__logo-container {
    position: relative;
    display: inline-block;
  }

  //&__logo-tree {
  //  position: absolute;
  //  top: 50%;
  //  left: 50%;
  //  transform: translate(-50%, -50%);
  //  width: 50px;
  //  height: 42px;
  //  opacity: 0.3;
  //  z-index: 0;
  //  pointer-events: none;
  //}

  &__logo-image {
    position: relative;
    width: 72px;
    height: 14px;
    display: block;
    z-index: 1;
  }

  //&__logo-snowflakes {
  //  position: absolute;
  //  top: -20px;
  //  left: -7px;
  //  width: 92px; /* 72px logo + 20px padding */
  //  height: 44px; /* 14px logo + 20px padding + 10px extra top */
  //  pointer-events: none;
  //  z-index: 2;
  //  opacity: 0;
  //  animation: fadeInSnowflakes 0.5s ease-in 1.5s forwards;
  //}
  //
  //@keyframes fadeInSnowflakes {
  //  from {
  //    opacity: 0;
  //  }
  //  to {
  //    opacity: 1;
  //  }
  //}

  &__group-menu-wrapper {
    align-self: stretch;
    display: flex;
    align-items: center;
  }

  &__group-menu {
    border-radius: 0 0 6px 6px !important;
    border-left: none !important;
    border-right: none !important;
    border-bottom: none !important;
    border-top: 1px solid var(--color-gray20) !important;
    box-shadow: 0 10px 10px 5px var(--color-black20) !important;
    background-color: var(--color-white);
    overflow: visible;

    .report-tabs__grouping-list-item-text, 
    .report-tabs__tab-icon--report,
    .report-tabs__grouping-list-item:hover .report-tabs__tab-icon--report {
      color: var(--color-graphite) !important;
    }

    .v-list {
      background-color: var(--color-white);
    }

    .report-tabs__grouping-list-item {
      background-color: transparent;

      .v-list-item__overlay,
      .v-list-item__underlay {
        display: none !important;
      }

      &:hover {
        background-color: var(--color-green10) !important;
      }
    }

    .report-tabs__tab-actions::after {
      border-left: 1px solid var(--color-gray5);
    }

    &--not-active {
      background-color: var(--color-bluedeep);

      .v-list,
      .report-tabs__grouping-list {
        background-color: transparent !important;
      }

      .report-tabs__grouping-list-item {
        background-color: var(--color-white20) !important;
        color: var(--color-white) !important;

        &:hover {
          background-color: var(--color-white40) !important;
        }
      }

      .report-tabs__grouping-list-item-text,
      .report-tabs__tab-icon--report,
      .report-tabs__grouping-list-item:hover .report-tabs__tab-icon--report,
      .report-tabs__grouping-list-item .v-list-item-title,
      .report-tabs__grouping-list-item .v-list-item__content {
        color: var(--color-white) !important;
      }

      .report-tabs__tab-icon-content--close {
        color: var(--color-white) !important;
      }

      .bookmark-add__tab-icon-bookmark:not(.bookmark-add__tab-icon-bookmark--selected) {
        color: var(--color-white);
      }

      .report-tabs__grouping-list-item-icon {
        color: var(--color-white) !important;
      }
    }

    @media (min-width: 600px) {
      min-width: 400px !important;
      max-width: 400px !important;
    }
  }

  &__grouping-list {
    padding: 0;
    max-height: 420px;
    overflow: auto;
  }

  &__grouping-list-item-content {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  &__grouping-list-item-main {
    display: flex;
    align-items: center;
    overflow-x: hidden;
  }

  &__grouping-list-item-tooltip {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow-x: hidden;
    overflow-y: hidden;
  }

  &__grouping-list-item-text  {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow-x: hidden;
    overflow-y: hidden;
    display: block;
  }

  &__grouping-list-item {
    min-height: 28px !important;
    padding: 0 8px 0 7px !important;
    font-size: 13px;

    &:hover {
      .report-tabs__tab-icon--report {
        color: var(--color-green) !important;
      }
    }

    &--active {
      .report-tabs__grouping-list-item-text {
        font-weight: bold;
      }
    }

    &-icon {
      color: var(--color-graphite) !important;
    }

    .report-tabs__tab-icon {
      padding-right: 5px;
      color: var(--color-gray20);
    }

    .v-icon {
      font-size: 12px;
    }
  }

  .v-toolbar &.v-tabs {
    min-width: 0;
  }

  &__tab {
    flex: 0 1 auto;

    &--hide-tabs {
        display: none;
    }

    @media (max-width: 600px) {
      &--plain {
        display: none;
      }

      &--grouping, 
      &--hide-tabs.report-tabs__tab {
        display: flex;
        max-width: 100%;
        width: 100%;

        &.v-tabs__item,
        .v-tabs__item {
          border: 1px solid var(--color-green) !important;
        }
      }

      .report-tabs__group-menu-activator {
        max-width: initial !important;
        width: calc(100% + 18px);
        flex-shrink: 0;
      }

      .report-tabs__group-menu-content-wrapper {
        width: 100%;
        padding-right: 18px;
      }

      .report-tabs__grouping-tab-text {
        display: inline-block;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: calc(100vw - 210px);
      }

      .report-tabs__group-menu-wrapper {
        flex-grow: 1;
      }
    }

    &.v-tabs__item,
    .v-tabs__item {
      padding: 6px 8px !important;
    }
  }

  &__group-menu-activator {
    width: 385px;
    max-width: 400px !important;
    height: 100%;
    display: flex;
    align-items: center;
  }

  &__grouping-list-item-tooltip {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow-x: hidden;
    overflow-y: hidden;
  }

  &__group-menu-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    overflow-x: hidden;
    overflow-y: hidden;
  }

  &__group-menu-content-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 383px;
    overflow: hidden;
  }

  &__tab-icon-content {
    color: var(--color-white) !important;
    vertical-align: baseline;

    &--close-all-tabs {
      padding-left: 5px
    }

    &--close {
      color: var(--color-graphite) !important;
    }
  }

  &__tab-icon {
    vertical-align: initial;
    line-height: 16px;
    align-self: center;

    &--caret {
      &::after {
        content: '';
        border-left: 1px solid var(--color-gray20);
        height: 16px;
        width: 1px;
        margin-left: 5px
      }
    }

    &--close {
      cursor: pointer;

      .ui-icon {
        color: inherit!important;
      }
      &:hover .ui-icon {
        color: var(--color-red) !important;
      }
    }
  }

  &__grouping-list &__tab-icon {
    padding-right: 5px !important;
  }

  &__tab-text {
    align-self: center !important;
    line-height: 16px !important;
  }

   &__tab-actions {
    display: flex;

    &::after {
      content: '';
      border-left: 1px solid var(--color-gray5);
      height: 16px;
      width: 1px;
      margin-left: 5px;
    }
  }

  &__tab--active &__tab-actions { 
    &::after {
      border-left: 1px solid var(--color-gray20);
    }
  }
}
</style>
